import { TopRelatedProps } from '@/types/product';
import dynamic from 'next/dynamic';

type IProps = {
  data: TopRelatedProps;
  className?: string;
  contentWrapCls?: string;
  title?: string;
};

const DynamicRelatedTopics = dynamic(() => import('@/components/pdp/TopRelatedModule'), { ssr: true });

function DynamicRelatedTopicsModule(props: IProps) {
  const { data } = props;
  if (!data.length) return null;
  return <DynamicRelatedTopics {...props} />;
}

export default DynamicRelatedTopicsModule;
